import { RefObject, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { size } from '../themes/online';
import { generateStr } from './common';

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < size.tabletS);

  useLayoutEffect(() => {
    const updateSize = (): void => {
      setIsMobile(window.innerWidth < size.tabletS);
    };
    window.addEventListener('resize', updateSize);
    return (): void => window.removeEventListener('resize', updateSize);
  }, []);

  return isMobile;
};

export const useOnScreen = (elementRef: RefObject<HTMLElement>) => {
  const [, triggerUpdate] = useState('');
  const isIntersecting = useRef(false);

  useEffect(() => {
    if (!elementRef.current) return;

    const observer = new IntersectionObserver(([entry]) => {
      isIntersecting.current = entry.isIntersecting;
      triggerUpdate(generateStr());
    });

    observer.observe(elementRef.current);

    return () => {
      observer.disconnect();
    };
  }, [elementRef.current]); // React only to changes in ref.current

  return isIntersecting.current;
};
